import { FC } from 'react';
import { Body } from 'atoms/Typography/Typography';
import styles from './subtitle.module.css';

export const Subtitle: FC<{ text: string }> = ({ text }) => {
  return (
    <Body type="lg" tag="h2" weight="medium" className={styles.subTitle}>
      {text}
    </Body>
  );
};
